// Angular
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";

import {
  NewActionNotificationComponent,
  NotificationConfig,
} from "../dialog/new-action-notification/new-action-notification.component";

import { CommonDeleteComponent } from "../dialog/common-delete-dialog/index.component";
import { getTranslation } from "../utils/utils";
export enum MessageType {
  Create,
  Read,
  Update,
  Delete,
}

@Injectable({
  providedIn: "root",
})
export class DialogService {
  /**
   * Service constructor
   *
   * @param snackBar: MatSnackBar
   * @param dialog: MatDialog
   */
  translation = null;
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {
    this.translation = getTranslation();
  }

  showLoadingNotification(
    config: Omit<
      NotificationConfig,
      "message" | "snackBar" | "status" | "type"
    > & { message?: string }
  ) {
    return this.snackBar.openFromComponent(NewActionNotificationComponent, {
      data: {
        ...config,
        message:
          config.message ||
          this.translation.DOWNLOAD_IS_IN_PROGRESS ||
          ".Download is in progress",
        snackBar: this.snackBar,
        type: "Loading",
      },
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: "new-action-notification",
    });
  }

  showNotification(
    message: string,
    config?: Omit<
      NotificationConfig,
      "message" | "snackBar" | "loadingCallback" | "type"
    > & {
      duration?: number;
      type?: Exclude<NotificationConfig["type"], "Loading">;
    }
  ) {
    return this.snackBar.openFromComponent(NewActionNotificationComponent, {
      data: {
        message,
        snackBar: this.snackBar,
        ...(config || {}),
      },
      duration: (config && config.duration) || 3000,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: "new-action-notification",
    });
  }
  // 删除确认弹窗
  deleteElement() {
    return this.dialog.open(CommonDeleteComponent, {
      data: {},
      panelClass: "rs-dialog-wrap",
    });
  }

  // 自定义文案通用弹窗的提示框
  showCommonDilaog(data?: {
    title?: string;
    description?: string| string[];
    saveBtnLabel?: string;
    cancelBtnLabel?: string;
    showErrorIcon?: boolean;
    size?: string;
    hideSaveBtn?: boolean;
    onCloseRequest?: (e: any) => Promise<boolean>;
    showZoomBtn?: boolean;
  }) {
    return this.dialog.open(CommonDeleteComponent, {
      data,
      panelClass: "rs-dialog-wrap",
    });
  }

  // 有改动未保存 的提示框
  showUnsavedChanges(data?: {
    title?: string;
    description?: string;
    saveBtnLabel?: string;
    cancelBtnLabel?: string;
    showErrorIcon?: boolean;
    size?: string;
    hideSaveBtn?: boolean;
  }) {
    let defaultData = {
      title: this.translation.UNSAVED_CHANGES || ".UNSAVED_CHANGES",
      description:
        this.translation.YOU_HAVE_UNSAVED_CHANGES_DO_YOU_WANT_TO_CONTINUE ||
        ".YOU_HAVE_UNSAVED_CHANGES_DO_YOU_WANT_TO_CONTINUE",
      saveBtnLabel: this.translation.SAVE_AND_LEAVE || ".SAVE_AND_LEAVE",
      discardBtnLabel:
        this.translation.DISCARD_AND_LEAVE || ".DISCARD_AND_LEAVE",
      cancelBtnLabel: this.translation.CANCEL || ".CANCEL",
      hideDiscardBtn: false,
      size: "medium",
      hideCloseIcon: true,
    };
    if (data) {
      data = Object.assign(defaultData, data);
    } else {
      data = defaultData;
    }
    // data.size = "medium";
    return this.dialog.open(CommonDeleteComponent, {
      data,
      panelClass: "rs-dialog-wrap",
    });
  }

  // 保存成功提示
  public showSucMsg(res) {
    this.showMessage(res, MessageType.Create);
  }

  // 更新成功提示
  public showUpdateMsg(res) {
    this.showMessage(res, MessageType.Update);
  }

  // 删除成功提示
  public showDelMsg(res) {
    this.showMessage(res, MessageType.Delete);
  }

  // 通用提示
  private showMessage(res, type = MessageType.Create) {
    let _saveMessage = this.translation.SAVESUCCESS || ".SAVESUCCESS";
    switch (type) {
      case MessageType.Update:
        _saveMessage = this.translation.UPDATESUCCESS || ".UPDATESUCCESS";
        break;
      case MessageType.Delete:
        _saveMessage = this.translation.DELETESUCCESS || ".DELETESUCCESS";
        break;
    }
    if (res.status === "ERROR") _saveMessage = res.messages[0].message;
    this.showNotification(_saveMessage, {
      status: res.status === "ERROR" ? "Error" : "Success",
    });
  }
}
